import React from "react";

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <h1 className="text-3xl md:text-4xl font-heading font-extrabold mb-6">About</h1>
      <div className="card-thali space-y-4 text-thali-ink/80">
        <p>PM POSHAN MDM Calculator is a free, independent helper tool built for school teachers, Headmasters and Mid Day Meal In-charges in Odisha, India.</p>
        <p>It calculates the exact daily cooking cost and rice/ingredient quantities for each class group — Balvatika, Primary, Upper Primary and High School — following the latest per-student cost norms, including the May 2025 auto-balanced vegetables rule and the nutrition laddoo policy.</p>
        <p>Save your daily entries and generate Daily, Weekly, Monthly (MDCF), Annual and Utilisation Certificate (UC) reports that you can download as PDF/Excel or share on WhatsApp.</p>
        <p className="text-sm text-thali-ink/60 border-t border-thali-turmeric/20 pt-4">This is an independent tool and not an official Government of India or Government of Odisha website. Always verify figures with official circulars.</p>
      </div>
    </div>
  );
}
